// react-router-dom components
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import poppinsregular2 from "./fonts/poppins-regular-webfont.woff2";

import "./index.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import AppContent from "components/common/AppContent";

/* ---------------- THEME ---------------- */

const theme = createTheme({
    typography: {
        fontFamily: "poppinsregular",
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                    font-family: 'poppinsregular';
                    src: url(${poppinsregular2}) format('woff2');
                }
            `,
        },
    },
});

/* ================= APP ================= */

function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
